import axios from 'axios';
import { API_BASE_URL } from '../config';

export const checkAuthAndRedirect = async (navigate) => {
  const token = localStorage.getItem('token');
  if (!token) {
    navigate('/auth?mode=login');
    return false;
  }

  try {
    await axios.get(`${API_BASE_URL}/validate_token`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return true;
  } catch (error) {
    console.error('Token verification failed:', error);
    localStorage.removeItem('token');
    navigate('/auth?mode=login');
    return false;
  }
};

export const checkAuth = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return false;
  }
  try {
    await axios.get(`${API_BASE_URL}/validate_token`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return true;
  } catch (error) {
    console.error('Token verification failed:', error);
    localStorage.removeItem('token');
    return false;
  }
};